import { ApiCollectionResponse, GetCollectionQueryParams } from '../../types';
import { ReadAudience } from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { GetAudiencesFilter } from '../../endpoints/audiences';

export const getAudiences = async (
  params: GetCollectionQueryParams<ReadAudience, GetAudiencesFilter>,
): Promise<ApiCollectionResponse<ReadAudience>> => {
  return await tinctApi.audiences.getAudiences(params);
};

export const useGetAudiences = (
  params: GetCollectionQueryParams<ReadAudience, GetAudiencesFilter>,
  options?: Omit<
    UseQueryOptions<ApiCollectionResponse<ReadAudience>, ApiError>,
    'queryKey'
  >,
) =>
  useQuery({
    queryKey: ['audiences', params],
    queryFn: () => getAudiences(params),
    ...options,
  });
